import { ShoppingCartItems } from '@/modules/moduleSubscription/types/ShoppingCart'

// a removed add-on leaves its subscription type behind - "{ buchhaltung: {} }" holds nothing to buy
const isCartEmpty = (items: ShoppingCartItems): boolean => !Object.values(items).some(products => Object.keys(products || {}).length)

export default isCartEmpty
